import React, { useEffect, useRef } from 'react'
import Header from './Header'
import Content from './Content'
import { motion } from 'framer-motion'

const LandingPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const ContactUsRef = useRef(null);

    const scrollToContactUs = () => {
        ContactUsRef.current?.scrollIntoView({
            behavior: "smooth",
        });
    };
    return (
        <motion.div
            className="min-h-screen bg-black text-white"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <Header onContactUsClick={scrollToContactUs}  />
            <Content ref={ContactUsRef} />
        </motion.div>
    )
}

export default LandingPage